<template>
  <div id="copy-descriptor" class="bg-wht">
    <div class="row">
      <div class="col-xs-12">
        <div>
          <loader v-if="loading"/>
          <div v-else-if="!loading">
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label for="copyFrom" class="form-label">Copy from</label>
                <select class="form-control" id="copyFrom" v-model="copyFrom">
                  <option value=""></option>
                  <option v-for="(opt, i) in this.otherTariffDescriptors" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MaiModal from '../../../../components/MaiModal'
  import API from '../../../../api/endpoints'
  import HelperMixin from '../../mixins/Helpers'
  import SheetMixin from './SheetMixin'
  import Loader from '../../../helpers/Loader'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  export default {
    name: 'SpreadsheetDescriptorCopy',
    components: {MaiModal, Loader},
    mixins: [HelperMixin, SheetMixin],
    props: {
      mainId: {
        type: Number,
        required: true
      },
      parentId: {
        type: Number,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        copyFrom: null,
        loading: true,
        otherTariffDescriptors: []
      }
    },
    computed: {
      level () {
        return this.type === 'Static' ? this.sheetDescAddition : this.sheetDescNote
      },
      isValid () {
        return this.copyFrom
      }
    },
    methods: {
      go () {
        if (this.copyFrom != null && this.copyFrom != '') {
          this.$http.post(API.SPREADSHEET_CLONE_BY_LEVEL(this.parentId), {descriptorToCopyId: this.copyFrom, level: this.level})
            .then(() => {
              this.$emit('close')
              this.$router.push({ name: 'Admin - Edit/View Spreadsheet Tariff Descriptor', params: { id: createRouteIdHash(this.parentId) } })
            })
        }
      },
      getForParent (parent) {
        return this.$http.get(API.GET_ENTITIES('spreadsheet-descriptor'), {
          params: {
            parent: parent
          }
        })
      },
      getRelatedData () {
        this.getForParent(this.mainId).then(({data}) => {
          let results = data.map(obj => this.unwrapData(obj))
          results.forEach((o) => {
            if (o.entityType === this.sheetDescLookup && o.id != this.parentId) {
              let descriptorName = this.getSystemOption(o.tariff).name + ' ' + o.name
              this.otherTariffDescriptors.push({id: o.id, name: descriptorName})
            }
          })
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Can not retrieve other lookup descriptors. Copying details from other lookup descriptors will not be available.' })
        }).then(() => { this.loading = false })
      },
      enableSave () {
        if (this.copyFrom != null && this.copyFrom != '') {
          this.$emit('enableSave', true)
        } else {
          this.$emit('enableSave', false)
        }
      }
    },
    watch: {
      mainId: {
        handler: 'getRelatedData',
        immediate: true
      },
      copyFrom: {
        handler: 'enableSave',
        immediate: true
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// SpreadsheetDescriptorCopy.vue?376fc062